import { render, staticRenderFns } from "./laborServices.vue?vue&type=template&id=1ec548b9&scoped=true&"
import script from "./laborServices.vue?vue&type=script&lang=js&"
export * from "./laborServices.vue?vue&type=script&lang=js&"
import style0 from "./laborServices.vue?vue&type=style&index=0&id=1ec548b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec548b9",
  null
  
)

export default component.exports